import { useCallback } from 'react';

import { AccessResourceKey } from 'hooks/data/files/types';
import useAccess from 'hooks/useAccess';
import { checkAccessToResource } from 'utilities/auth/access';

import { useIsDatasetComparisonEnabled } from './useIsDatasetComparisonEnabled';

export const useCanCompare = (): ((version: string) => boolean) => {
  const isEnabled = useIsDatasetComparisonEnabled();
  const { data: access } = useAccess();

  // The comparison endpoints answer 403 for a release without a scores licence, and signed-out users have no access data.
  return useCallback(
    (version: string) => isEnabled && checkAccessToResource(access, AccessResourceKey.SCORES, version),
    [isEnabled, access]
  );
};
